var map = {
	"./CONTACT.png": 57679,
	"./WOD/01.png": 96291,
	"./aiCard/mobile/ai-driven.png": 35682,
	"./aiCard/mobile/app_store_text.png": 11760,
	"./aiCard/mobile/arrow_left.png": 86914,
	"./aiCard/mobile/arrow_right.png": 87615,
	"./aiCard/mobile/bg_img.png": 92014,
	"./aiCard/mobile/card_games.png": 4045,
	"./aiCard/mobile/game_img_bg.png": 86595,
	"./aiCard/mobile/game_img_bg_active.png": 11862,
	"./aiCard/mobile/game_title.png": 45106,
	"./aiCard/mobile/google_play_text.png": 9487,
	"./aiCard/mobile/log_content_bg.png": 81573,
	"./aiCard/mobile/log_title.png": 30898,
	"./aiCard/mobile/news_bg.png": 72846,
	"./aiCard/mobile/news_more_bg.png": 80752,
	"./aiCard/mobile/news_title.png": 66949,
	"./aiCard/mobile/page_num_bg.png": 4313,
	"./aiCard/mobile/strategy.png": 81328,
	"./aiCard/mobile/swiper_banner1.png": 35921,
	"./aiCard/mobile/swiper_banner2.png": 14810,
	"./aiCard/mobile/swiper_banner3.png": 78915,
	"./aiCard/mobile/swiper_banner4.png": 2668,
	"./aiCard/mobile/swiper_banner5.png": 54933,
	"./aiCard/pc/Frame 342@2x.png": 63836,
	"./aiCard/pc/ai-driven.png": 54831,
	"./aiCard/pc/app_store_text.png": 16659,
	"./aiCard/pc/arrow_left.png": 56261,
	"./aiCard/pc/arrow_right.png": 89190,
	"./aiCard/pc/banner_icon_bg.png": 36972,
	"./aiCard/pc/banner_icon_bg2.png": 46532,
	"./aiCard/pc/banner_icon_bg3.png": 26125,
	"./aiCard/pc/bg_img.png": 93757,
	"./aiCard/pc/card_games.png": 84066,
	"./aiCard/pc/game_img_bg.png": 38986,
	"./aiCard/pc/game_img_bg_active.png": 39481,
	"./aiCard/pc/game_title.png": 28745,
	"./aiCard/pc/google_play_text.png": 2288,
	"./aiCard/pc/icon1.png": 26354,
	"./aiCard/pc/icon2.png": 74537,
	"./aiCard/pc/icon3.png": 50336,
	"./aiCard/pc/log_content_bg.png": 47334,
	"./aiCard/pc/log_title.png": 13495,
	"./aiCard/pc/news_bg.png": 64599,
	"./aiCard/pc/news_title.png": 30434,
	"./aiCard/pc/page_num_bg.png": 60044,
	"./aiCard/pc/strategy.png": 23127,
	"./aiCard/pc/swiper_banner1.png": 69146,
	"./aiCard/pc/swiper_banner2.png": 93809,
	"./aiCard/pc/swiper_banner3.png": 53864,
	"./aiCard/pc/swiper_banner4.png": 29031,
	"./aiCard/pc/swiper_banner5.png": 41342,
	"./arrow_down.png": 89589,
	"./arrow_up.png": 4350,
	"./back.png": 69866,
	"./blog.png": 26623,
	"./blog_bg.png": 76357,
	"./btn1.png": 75002,
	"./btn2.png": 96113,
	"./close.png": 86415,
	"./come_on_bite_me/01.jpg": 68899,
	"./come_on_bite_me/02.jpg": 39188,
	"./come_on_bite_me/03.jpg": 53521,
	"./come_on_bite_me/04.jpg": 98914,
	"./come_on_bite_me/05.jpg": 90623,
	"./confirm.png": 35283,
	"./confirmbg.png": 77842,
	"./contack_eamil.png": 10961,
	"./contack_ins.png": 20594,
	"./contact_bd.png": 66366,
	"./contact_bg.png": 68469,
	"./contact_fb.png": 38116,
	"./contact_ig.png": 31676,
	"./contact_tt.png": 4472,
	"./contact_tw.png": 83,
	"./contact_yt.png": 55095,
	"./dian.png": 91207,
	"./dian2.png": 92117,
	"./email/blank_logo.png": 10300,
	"./email/email_bg_icon.png": 92412,
	"./home/3_00.png": 40029,
	"./home/banner_card1.png": 99471,
	"./home/banner_card2.png": 80564,
	"./home/banner_card3.png": 1693,
	"./home/banner_card4.png": 5346,
	"./home/banner_card5.png": 26475,
	"./home/contact_banner.png": 13882,
	"./home/contact_banner_m.png": 11650,
	"./home/contact_bg.png": 65349,
	"./home/contact_bg2.png": 84115,
	"./home/contact_bg_m.png": 96657,
	"./home/digital-Layers1.png": 98715,
	"./home/digital-Layers2.png": 1152,
	"./home/digital-Layers3.png": 25353,
	"./home/digital-Layers4.png": 75382,
	"./home/digital-Layers5.png": 29183,
	"./home/digital-game-bg-m.png": 36036,
	"./home/digital-game-bg.png": 17530,
	"./home/game_info_bg.png": 24614,
	"./home/home_footer_img.png": 66266,
	"./home/home_footer_img_m.png": 43554,
	"./home/hover_title.png": 11462,
	"./home/hover_title2.png": 92774,
	"./home/index_banner1.jpg": 36089,
	"./home/index_banner1.png": 34177,
	"./home/index_banner1_m.png": 80093,
	"./home/index_banner1_ms.png": 914,
	"./home/index_banner2.png": 85194,
	"./home/index_banner2_m.png": 65010,
	"./home/index_banner3.png": 35955,
	"./home/index_banner3_m.png": 42067,
	"./home/index_banner4.png": 35996,
	"./home/index_banner4_m.png": 29680,
	"./home/index_banner5.png": 69861,
	"./home/index_banner5_m.png": 75729,
	"./home/index_banner_lavandula.png": 12363,
	"./home/index_banner_lavandula_m.jpg": 98531,
	"./home/index_banner_lavandula_m.png": 18795,
	"./home/news_arrow.png": 97000,
	"./home/news_banner.png": 96761,
	"./home/news_banner_m.png": 21141,
	"./home/sprite-min4.png": 82687,
	"./home/sprite-min5.png": 4598,
	"./log.png": 133,
	"./log2.png": 12499,
	"./lunbo1.jpg": 88294,
	"./lunbo2.jpg": 16049,
	"./lunbo3.jpg": 1716,
	"./mail.png": 45046,
	"./mecha_snap/01.jpg": 67592,
	"./mecha_snap/02.jpg": 78519,
	"./mecha_snap/03.jpg": 91002,
	"./mecha_snap/04.jpg": 27465,
	"./mecha_snap/05.jpg": 72204,
	"./mecha_snap/06.jpg": 49179,
	"./mobile/adventure/adventure_banner.jpg": 90295,
	"./mobile/adventure/adventure_banner2.jpg": 57204,
	"./mobile/adventure/adventure_banner3.jpg": 35729,
	"./mobile/adventure/adventure_bg.jpg": 52067,
	"./mobile/adventure/adventure_bg02.jpg": 81457,
	"./mobile/adventure/adventure_bg03.jpg": 67732,
	"./mobile/adventure/adventure_bg04.jpg": 4895,
	"./mobile/adventure/adventure_bg05.jpg": 92226,
	"./mobile/adventure/adventure_title.png": 22966,
	"./mobile/adventure/adventure_title2.png": 75862,
	"./mobile/aiCard/banner1.jpg": 42956,
	"./mobile/aiCard/banner2.jpg": 85755,
	"./mobile/aiCard/banner3.jpg": 14622,
	"./mobile/aiCard/banner4.jpg": 25445,
	"./mobile/aiCard/banner5.jpg": 63080,
	"./mobile/aiCard/title_img.png": 33785,
	"./mobile/aiCard/title_img2.png": 37935,
	"./mobile/arrow1.png": 93798,
	"./mobile/arrow2.png": 77565,
	"./mobile/btn_gf.png": 73310,
	"./mobile/btn_readmore.png": 66246,
	"./mobile/close.png": 62604,
	"./mobile/confirm_bg.png": 70956,
	"./mobile/contact_banner.png": 74131,
	"./mobile/contact_bg.png": 61244,
	"./mobile/hans.png": 1910,
	"./mobile/logo2.png": 23921,
	"./mobile/luna.png": 15452,
	"./mobile/menu.png": 84715,
	"./mobile/partner_1.png": 91254,
	"./mobile/partner_2.png": 5229,
	"./mobile/partner_3.png": 51332,
	"./mobile/partner_4.png": 15195,
	"./mobile/partner_5.png": 370,
	"./mobile/product_aigame.png": 89950,
	"./mobile/product_all.png": 12569,
	"./mobile/product_all2.png": 87663,
	"./mobile/product_board.png": 24064,
	"./mobile/product_board2.png": 4304,
	"./mobile/product_caif.png": 12691,
	"./mobile/product_conglin.png": 59564,
	"./mobile/product_elc.png": 72970,
	"./mobile/product_game.png": 43384,
	"./mobile/product_game2.png": 72472,
	"./mobile/product_witness.png": 82441,
	"./mobile/product_wod.png": 13086,
	"./mobile/product_xiyou.png": 2178,
	"./mobile/swiper1.jpg": 84461,
	"./mobile/swiper2.jpg": 15234,
	"./mobile/swiper3.jpg": 6943,
	"./mobile/swiper4.jpg": 12308,
	"./mobile/swiper5.jpg": 465,
	"./mobile/swiper6.jpg": 68262,
	"./mobile/switch1.png": 95701,
	"./mobile/switch2.png": 9950,
	"./mobile/tailor/banner1.jpg": 83993,
	"./mobile/tailor/banner2.jpg": 85326,
	"./mobile/tailor/banner3.jpg": 64811,
	"./mobile/tailor/banner4.jpg": 61208,
	"./mobile/team_bg.png": 89687,
	"./mobile/westGame/banner1.jpg": 92395,
	"./mobile/westGame/banner2.jpg": 7740,
	"./mobile/westGame/banner3.jpg": 94617,
	"./mobile/westGame/banner4.jpg": 57898,
	"./mobile/white_logo.png": 86909,
	"./mobile/widerness/banner.png": 13719,
	"./mobile/widerness/bg.png": 58208,
	"./mobile/widerness/bg_Fragments1.png": 71657,
	"./mobile/widerness/bg_Fragments2.png": 23474,
	"./mobile/widerness/bg_Fragments3.png": 45019,
	"./mobile/widerness/bg_Fragments4.png": 90212,
	"./mobile/widerness/bg_Fragments5.png": 53453,
	"./mobile/widerness/big_title_img1.png": 65931,
	"./mobile/widerness/big_title_img2.png": 96080,
	"./mobile/widerness/big_title_img3.png": 92985,
	"./mobile/widerness/component_img1.png": 55871,
	"./mobile/widerness/component_img2.png": 54244,
	"./mobile/widerness/component_img3.png": 33837,
	"./mobile/widerness/game_num1.png": 29269,
	"./mobile/widerness/game_num2.png": 27166,
	"./mobile/widerness/more_bt_bg.png": 4783,
	"./mobile/widerness/paper_bg1.png": 59996,
	"./mobile/widerness/paper_bg2.png": 83927,
	"./mobile/widerness/paper_bg3.png": 84430,
	"./mobile/widerness/paper_clip.png": 96354,
	"./mobile/widerness/photo_preview/product10_preview.png": 64786,
	"./mobile/widerness/photo_preview/product1_preview.png": 66530,
	"./mobile/widerness/photo_preview/product2_preview.png": 31509,
	"./mobile/widerness/photo_preview/product3_preview.png": 3368,
	"./mobile/widerness/photo_preview/product4_preview.png": 88819,
	"./mobile/widerness/photo_preview/product5_preview.png": 6198,
	"./mobile/widerness/photo_preview/product6_preview.png": 88457,
	"./mobile/widerness/photo_preview/product7_preview.png": 85900,
	"./mobile/widerness/photo_preview/product8_preview.png": 80215,
	"./mobile/widerness/photo_preview/product9_preview.png": 57354,
	"./mobile/widerness/product1.png": 88527,
	"./mobile/widerness/product10.png": 96671,
	"./mobile/widerness/product2.png": 14036,
	"./mobile/widerness/product3.png": 30717,
	"./mobile/widerness/product4.png": 42818,
	"./mobile/widerness/product5.png": 63947,
	"./mobile/widerness/product6.png": 76304,
	"./mobile/widerness/product7.png": 82553,
	"./mobile/widerness/product8.png": 66990,
	"./mobile/widerness/product9.png": 96215,
	"./mobile/widerness/product_cover1.png": 23543,
	"./mobile/widerness/product_cover2.png": 65436,
	"./mobile/widerness/text_bg.png": 23680,
	"./mobile/widerness/three_icon1.png": 31824,
	"./mobile/widerness/three_icon2.png": 1675,
	"./mobile/widerness/three_icon3.png": 80546,
	"./mobile/winner_banner.jpg": 45970,
	"./mobile/winner_bg.jpg": 61449,
	"./mobile/winner_bg2.jpg": 24743,
	"./mobile/winner_title.png": 59816,
	"./mobile/winner_title2.png": 82504,
	"./mobile/winner_video_bg.png": 82421,
	"./nav_bg.png": 76832,
	"./news_bg.png": 82682,
	"./news_bg_left_01.png": 53280,
	"./news_bg_left_02.png": 8315,
	"./news_bg_right.png": 92849,
	"./news_corner_left.png": 93450,
	"./news_corner_right.png": 89863,
	"./pc/adventure/adventure_banner.jpg": 92459,
	"./pc/adventure/adventure_banner2.jpg": 56065,
	"./pc/adventure/adventure_banner3.jpg": 61668,
	"./pc/adventure/adventure_bg.jpg": 10776,
	"./pc/adventure/adventure_bg02.jpg": 32578,
	"./pc/adventure/adventure_bg03.jpg": 24287,
	"./pc/adventure/adventure_bg04.jpg": 56500,
	"./pc/adventure/adventure_bg05.jpg": 70833,
	"./pc/adventure/adventure_title.png": 52831,
	"./pc/adventure/adventure_title2.png": 58365,
	"./pc/aiCard/banner1.jpg": 28511,
	"./pc/aiCard/banner2.jpg": 44784,
	"./pc/aiCard/banner3.jpg": 6029,
	"./pc/aiCard/bg.jpg": 3143,
	"./pc/aiCard/title_img.png": 1490,
	"./pc/aiCard/title_img2.png": 70874,
	"./pc/btn_gf.png": 66001,
	"./pc/btn_readmore.png": 68093,
	"./pc/confirm_bg.png": 21339,
	"./pc/contact_banner.png": 38832,
	"./pc/contact_bg.png": 53851,
	"./pc/email_bg_icon.png": 74103,
	"./pc/hans.png": 94873,
	"./pc/logo2.png": 1508,
	"./pc/luna.png": 4987,
	"./pc/new4.jpg": 44507,
	"./pc/news1.png": 53279,
	"./pc/news2.png": 39716,
	"./pc/news3.png": 65869,
	"./pc/news4.png": 84306,
	"./pc/partner_1.png": 19707,
	"./pc/partner_2.png": 22144,
	"./pc/partner_3.png": 46345,
	"./pc/partner_4.png": 96374,
	"./pc/partner_5.png": 50175,
	"./pc/partner_arrowl.png": 86949,
	"./pc/partner_arrowr.png": 7707,
	"./pc/product_aigame.png": 73149,
	"./pc/product_all.png": 94696,
	"./pc/product_all2.png": 93864,
	"./pc/product_board.png": 95501,
	"./pc/product_board2.png": 26667,
	"./pc/product_caif.png": 272,
	"./pc/product_conglin.png": 39265,
	"./pc/product_game.png": 83139,
	"./pc/product_game2.png": 73177,
	"./pc/product_game_banner.png": 50726,
	"./pc/product_witness.png": 73000,
	"./pc/product_wod.png": 39959,
	"./pc/product_xiyou.png": 87967,
	"./pc/swiper1.jpg": 79192,
	"./pc/swiper2.jpg": 16647,
	"./pc/swiper3.jpg": 60810,
	"./pc/swiper4.jpg": 31705,
	"./pc/swiper5.jpg": 10652,
	"./pc/swiper6.jpg": 2635,
	"./pc/swiper_img1.png": 46504,
	"./pc/swiper_img2.png": 8483,
	"./pc/tailor/banner.jpg": 25499,
	"./pc/tailor/banner2.jpg": 42353,
	"./pc/tailor/banner3.jpg": 28628,
	"./pc/tailor/banner4.jpg": 49439,
	"./pc/team_bg.png": 83694,
	"./pc/thr2.png": 79133,
	"./pc/westGame/banner1.jpg": 47804,
	"./pc/westGame/banner2.jpg": 16107,
	"./pc/westGame/banner3.jpg": 38062,
	"./pc/westGame/banner4.jpg": 73685,
	"./pc/white_logo.png": 7094,
	"./pc/widerness/banner.jpg": 99596,
	"./pc/widerness/banner_next.png": 13102,
	"./pc/widerness/banner_prev.png": 57102,
	"./pc/widerness/bg.png": 34419,
	"./pc/widerness/bg_fragments1.png": 26792,
	"./pc/widerness/bg_fragments2.png": 63651,
	"./pc/widerness/bg_fragments3.png": 99546,
	"./pc/widerness/bg_fragments4.png": 39669,
	"./pc/widerness/bg_fragments5.png": 87404,
	"./pc/widerness/bg_fragments6.png": 6407,
	"./pc/widerness/bg_fragments7.png": 53918,
	"./pc/widerness/big_title_img1.png": 81040,
	"./pc/widerness/big_title_img2.png": 68683,
	"./pc/widerness/big_title_img3.png": 47554,
	"./pc/widerness/component_img1.png": 47508,
	"./pc/widerness/component_img2.png": 92348,
	"./pc/widerness/component_img3.png": 84870,
	"./pc/widerness/game_num1.png": 16908,
	"./pc/widerness/game_num2.png": 85383,
	"./pc/widerness/more_bt_bg.png": 34084,
	"./pc/widerness/more_img1.png": 96060,
	"./pc/widerness/more_img2.png": 37815,
	"./pc/widerness/pagination.png": 12018,
	"./pc/widerness/pagination_active.png": 51185,
	"./pc/widerness/paper_bg1.png": 56197,
	"./pc/widerness/paper_bg2.jpg": 53034,
	"./pc/widerness/paper_bg3.png": 49796,
	"./pc/widerness/paper_clip.png": 71381,
	"./pc/widerness/photo_preview/product10_preview.png": 72115,
	"./pc/widerness/photo_preview/product1_preview.png": 50361,
	"./pc/widerness/photo_preview/product2_preview.png": 89030,
	"./pc/widerness/photo_preview/product3_preview.png": 16227,
	"./pc/widerness/photo_preview/product4_preview.png": 98456,
	"./pc/widerness/photo_preview/product5_preview.png": 55973,
	"./pc/widerness/photo_preview/product6_preview.png": 4562,
	"./pc/widerness/photo_preview/product7_preview.png": 79327,
	"./pc/widerness/photo_preview/product8_preview.png": 39620,
	"./pc/widerness/photo_preview/product9_preview.png": 31553,
	"./pc/widerness/product1.png": 53700,
	"./pc/widerness/product10.png": 34878,
	"./pc/widerness/product2.png": 90559,
	"./pc/widerness/product3.png": 93622,
	"./pc/widerness/product4.png": 17353,
	"./pc/widerness/product4_preview.png": 40924,
	"./pc/widerness/product5.png": 39232,
	"./pc/widerness/product6.png": 17563,
	"./pc/widerness/product7.png": 2738,
	"./pc/widerness/product8.png": 73589,
	"./pc/widerness/product9.png": 37676,
	"./pc/widerness/product_cover1.png": 97544,
	"./pc/widerness/product_cover2.png": 34403,
	"./pc/widerness/text_bg.png": 54777,
	"./pc/widerness/three_icon.png": 86674,
	"./pc/widerness/video_bg.png": 22835,
	"./pc/winner_banner.jpg": 47027,
	"./pc/winner_bg.jpg": 56160,
	"./pc/winner_bg2.jpg": 40699,
	"./pc/winner_title.png": 56407,
	"./pc/winner_title2.png": 34501,
	"./pc/winner_title3.png": 16988,
	"./pc/winner_video_bg.png": 6876,
	"./product/back_icon.png": 76428,
	"./product/bga.png": 81,
	"./product/close-icon.png": 44245,
	"./product/close-red.png": 84909,
	"./product/close.png": 98791,
	"./product/comingSoon.png": 53923,
	"./product/comment-icon.png": 94896,
	"./product/creator-arrow.png": 17519,
	"./product/mobile/bga.png": 55242,
	"./product/mobile/close-icon.png": 59128,
	"./product/mobile/comingSoon.png": 19702,
	"./product/mobile/comment-icon.png": 81761,
	"./product/mobile/creator-arrow.png": 30088,
	"./product/mobile/pay-type1.png": 31116,
	"./product/mobile/pay-type2.png": 50119,
	"./product/mobile/pay-type3.png": 97630,
	"./product/mobile/shop_car.png": 12533,
	"./product/mobile/soldOut.png": 54562,
	"./product/mobile/star-active.png": 15359,
	"./product/mobile/star.png": 79282,
	"./product/more_img2.png": 80048,
	"./product/pause-icon.png": 40627,
	"./product/pay-type1.png": 49379,
	"./product/pay-type2.png": 12520,
	"./product/pay-type3.png": 52465,
	"./product/product_banner.png": 42889,
	"./product/product_bg1.png": 80137,
	"./product/product_bg2.png": 31954,
	"./product/product_bg3.png": 37147,
	"./product/shop_car.png": 91036,
	"./product/shop_car2.png": 66676,
	"./product/sku-pay-img.png": 61839,
	"./product/soldOut.png": 50321,
	"./product/star-active.png": 22888,
	"./product/star.png": 98843,
	"./product1.png": 93373,
	"./product2.png": 12166,
	"./product3.png": 99740,
	"./product4.png": 8336,
	"./product_bg.png": 29522,
	"./product_logo.png": 40542,
	"./products.png": 73807,
	"./tag-hot.png": 89113,
	"./tag-new.png": 80238,
	"./team.png": 79880,
	"./team/team_Img.png": 80066,
	"./team/team_banner.png": 66261,
	"./team/team_banner_m.png": 90401,
	"./team/team_logo.png": 40442,
	"./team_avatar1.png": 15625,
	"./team_avatar2.png": 67442,
	"./team_bg.png": 71276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;